// import { useMemo, useState } from "react";
// import { useMsal } from "@azure/msal-react";
// import { useNavigate } from "react-router-dom";
// import PortalLogo from "./PortalLogo";
// import { LogOut } from "lucide-react";

// /* =========================================
//    PROFILE MODAL
// ========================================= */

// function ProfileModal({ account, onClose }) {
//   if (!account) return null;

//   //const roles = account?.idTokenClaims?.roles || [];

//   return (
//     <div style={styles.profileBackdrop} onClick={onClose}>
//       <div
//         style={styles.profileModal}
//         onClick={(event) => event.stopPropagation()}
//       >
//         <div style={styles.profileHeader}>
//           <h3 style={styles.profileTitle}>User Profile</h3>

//           <button
//             style={styles.closeButton}
//             onClick={onClose}
//             aria-label="Close profile modal"
//           >
//             ✕
//           </button>
//         </div>

//         <div style={styles.profileBody}>
//           <ProfileRow
//             label="Full Name"
//             value={account.name || account.username}
//           />

//           <ProfileRow label="Email Address" value={account.username} />

        
//         </div>
//       </div>
//     </div>
//   );
// }

// function ProfileRow({ label, value }) {
//   return (
//     <div style={styles.profileRow}>
//       <span style={styles.profileLabel}>{label}</span>

//       <span style={styles.profileValue}>{value}</span>
//     </div>
//   );
// }

// /* =========================================
//    TOPBAR
// ========================================= */

// export default function Topbar() {
//   const { accounts, instance } = useMsal();

//   const navigate = useNavigate();

//   const [showProfile, setShowProfile] = useState(false);

//   const currentUser = accounts?.[0];

//   const displayName = currentUser?.name || currentUser?.username || "User";

//   const email = currentUser?.username || "";

//   const initials = useMemo(() => {
//     if (!displayName) return "U";

//     return displayName
//       .split(" ")
//       .map((part) => part[0]?.toUpperCase())
//       .slice(0, 2)
//       .join("");
//   }, [displayName]);

//   /* =========================================
//      LOGOUT HANDLER
//   ========================================= */

//   const handleLogout = async () => {
//     try {
//       await instance.logoutRedirect({
//         account: currentUser,
//       });
//     } catch {
//       try {
//         await instance.logoutPopup({
//           account: currentUser,
//         });

//         window.location.href = "/";
//       } catch (error) {
//         console.error("Logout failed:", error);
//       }
//     }
//   };

//   /* =========================================
//      UI
//   ========================================= */

//   return (
//     <>
//       <header style={styles.wrapper}>
//         {/* BRANDING */}
//         <div
//           className="topbar-left"
//           onClick={() => navigate("/")}
//           role="button"
//           tabIndex={0}
//         >
//           <PortalLogo variant="topbar" />
//         </div>

//         {/* USER ACTIONS */}

//         <div style={styles.right}>
//           <div
//             style={styles.userCard}
//             onClick={() => setShowProfile(true)}
//             role="button"
//           >
//             <div style={styles.avatar}>{initials}</div>

//             <div>
//               <div style={styles.userName}>{displayName}</div>

//               <div style={styles.userEmail}>{email}</div>
//             </div>
//           </div>

//           <button style={styles.logoutButton} onClick={handleLogout}>
//             <LogOut size={16} />
//             Sign Out
//           </button>
//         </div>
//       </header>

//       {showProfile && (
//         <ProfileModal
//           account={currentUser}
//           onClose={() => setShowProfile(false)}
//         />
//       )}
//     </>
//   );
// }

// /* =========================================
//    STYLES
// ========================================= */

// const styles = {
//   wrapper: {
//     height: "74px",
//     background: "#ffffff",
//     borderBottom: "1px solid #e2e8f0",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     padding: "0 28px",
//     position: "sticky",
//     top: 0,
//     zIndex: 100,
//   },

//   left: {
//     display: "flex",
//     alignItems: "center",
//     gap: "16px",
//     cursor: "pointer",
//   },

//   logoIcon: {
//     width: "42px",
//     height: "42px",
//     border: "2px solid #64748b",
//     color: "#64748b",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "18px",
//     fontWeight: "700",
//   },

//   title: {
//     fontSize: "30px",
//     fontWeight: "700",
//     color: "#0f172a",
//     lineHeight: 1,
//     letterSpacing: "0.03em",
//   },

//   subTitle: {
//     fontSize: "11px",
//     color: "#60a5fa",
//     letterSpacing: "0.22em",
//     marginTop: "6px",
//   },

//   right: {
//     display: "flex",
//     alignItems: "center",
//     gap: "14px",
//   },

//   userCard: {
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//     background: "#f8fafc",
//     border: "1px solid #e2e8f0",
//     padding: "8px 14px",
//     borderRadius: "14px",
//     cursor: "pointer",
//     transition: "all 0.2s ease",
//   },

//   avatar: {
//     width: "40px",
//     height: "40px",
//     borderRadius: "50%",
//     background: "#dbeafe",
//     color: "#2563eb",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontWeight: "700",
//     fontSize: "14px",
//   },

//   userName: {
//     fontSize: "14px",
//     fontWeight: "600",
//     color: "#0f172a",
//   },

//   userEmail: {
//     fontSize: "12px",
//     color: "#64748b",
//     marginTop: "2px",
//   },

//   logoutButton: {
//     height: "42px",
//     padding: "0 16px",
//     border: "none",
//     borderRadius: "12px",
//     background: "#0f172a",
//     color: "#ffffff",
//     fontSize: "14px",
//     fontWeight: "600",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     gap: "8px",
//     transition: "all 0.2s ease",
//   },

//   /* PROFILE MODAL */

//   profileBackdrop: {
//     position: "fixed",
//     inset: 0,
//     background: "rgba(15, 23, 42, 0.55)",
//     backdropFilter: "blur(4px)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 1000,
//   },

//   profileModal: {
//     width: "520px",
//     background: "#ffffff",
//     borderRadius: "20px",
//     padding: "24px",
//     boxShadow: "0 20px 45px rgba(0, 0, 0, 0.18)",
//   },

//   profileHeader: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     marginBottom: "20px",
//   },

//   profileTitle: {
//     margin: 0,
//     fontSize: "20px",
//     fontWeight: "700",
//     color: "#0f172a",
//   },

//   closeButton: {
//     border: "none",
//     background: "transparent",
//     cursor: "pointer",
//     fontSize: "18px",
//     color: "#64748b",
//   },

//   profileBody: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "16px",
//   },

//   profileRow: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "6px",
//   },

//   profileLabel: {
//     fontSize: "12px",
//     fontWeight: "700",
//     color: "#64748b",
//     textTransform: "uppercase",
//     letterSpacing: "0.08em",
//   },

//   profileValue: {
//     fontSize: "14px",
//     color: "#0f172a",
//     wordBreak: "break-word",
//   },
// };

import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import PortalLogo from "./PortalLogo";
import UserMenu from "./UserMenu";
import WorkspaceSwitch from "./WorkspaceSwitch";
import "./Topbar.css";

function TopbarLogo({ className, onNavigate }) {
  return (
    <div
      className={className}
      onClick={onNavigate}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          onNavigate();
        }
      }}
      role="button"
      tabIndex={0}
    >
      <PortalLogo variant="topbar" />
    </div>
  );
}

export default function Topbar({ onMenuToggle, isMenuOpen = false }) {
  const navigate = useNavigate();
  const goHome = () => navigate("/");

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button
          type="button"
          className="topbar-menu-btn"
          onClick={onMenuToggle}
          aria-expanded={isMenuOpen}
          aria-label={
            isMenuOpen ? "Close navigation menu" : "Open navigation menu"
          }
        >
          {isMenuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>

        <TopbarLogo className="topbar-logo" onNavigate={goHome} />
      </div>

      <div className="topbar-right">
        <WorkspaceSwitch />
        <UserMenu placement="topbar" />
      </div>
    </header>
  );
}
